"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = forkPutEffect;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
// In redux-saga, if we call the following effects in order, we might miss the take('C').
// 1. take('A')
// 2. put({ type: 'B' })
// 3. take('C')

// We need to modify step 2 to:
// 2. fork(function* () { yield put({ type: 'B' }) })

// This is a helper function for this purpose.

function forkPutEffect() {
  for (var _len = arguments.length, actions = new Array(_len), _key = 0; _key < _len; _key++) {
    actions[_key] = arguments[_key];
  }
  return (0, _effects.fork)( /*#__PURE__*/_regenerator["default"].mark(function forkPut() {
    var _i, _actions, action;
    return _regenerator["default"].wrap(function forkPut$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _i = 0, _actions = actions;
          case 1:
            if (!(_i < _actions.length)) {
              _context.next = 8;
              break;
            }
            action = _actions[_i];
            _context.next = 5;
            return (0, _effects.put)(action);
          case 5:
            _i++;
            _context.next = 1;
            break;
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, forkPut);
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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